import {
  PersonOutlined,
  SwapHorizOutlined,
  PauseCircleOutlined,
  LibraryBooksOutlined,
  ChecklistRtlOutlined,
  DescriptionOutlined,
  NewspaperOutlined,
} from "@mui/icons-material";
import { blue } from "@mui/material/colors";
import { Link, useLocation } from "react-router-dom";
import React from "react";

const navLinks = [
  { to: "/", icon: <PersonOutlined />, label: "Profile" },
  { to: "/change-course", icon: <SwapHorizOutlined />, label: "Course Change" },
  { to: "/defer", icon: <PauseCircleOutlined />, label: "Deferment" },
  { to: "/apply", icon: <LibraryBooksOutlined />, label: "Courses" },
  { to: "/transcript", icon: <DescriptionOutlined />, label: "Transcript" },
  { to: "/newsletter", icon: <NewspaperOutlined />, label: "Newsletter" },
  {
    to: "/view-requests",
    icon: <ChecklistRtlOutlined />,
    label: "Applications",
  },
];

const SideBar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const getLinkClasses = (path) => {
    const baseClasses =
      "p-3 flex row-span-1 transition-all duration-200 rounded-lg mx-2 my-1";
    const activeClasses = "bg-blue-600 text-white shadow-lg";
    const inactiveClasses = "hover:bg-blue-100 text-blue-950";

    return `${baseClasses} ${isActive(path) ? activeClasses : inactiveClasses}`;
  };

  const getMobileLinkClasses = (path) => {
    const baseClasses =
      "block p-3 transition-all duration-200 rounded-lg mx-2 my-1";
    const activeClasses = "bg-blue-600 text-white shadow-lg";
    const inactiveClasses = "hover:bg-blue-100 text-blue-950";

    return `${baseClasses} ${isActive(path) ? activeClasses : inactiveClasses}`;
  };

  const getIconColor = (path) => {
    return isActive(path) ? "white" : blue[900];
  };

  const getTextClasses = (path) => {
    const baseClasses = "grow text-md font-semibold whitespace-nowrap";
    const activeClasses = "text-white";
    const inactiveClasses = "text-blue-950";

    return `${baseClasses} ${isActive(path) ? activeClasses : inactiveClasses}`;
  };

  const getMobileTextClasses = (path) => {
    const baseClasses = "text-md font-semibold whitespace-nowrap";
    const activeClasses = "text-white";
    const inactiveClasses = "text-blue-950";

    return `${baseClasses} ${isActive(path) ? activeClasses : inactiveClasses}`;
  };

  return (
    <div className="bg-white p-2">
      <div className="flex items-center justify-between">
        <div className="hidden lg:block w-full">
          <div className="grid grid-rows-7 gap-1">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.to}
                className={getLinkClasses(link.to)}
              >
                {React.cloneElement(link.icon, {
                  className: "flex-none mx-2",
                  sx: { color: getIconColor(link.to), fontSize: 25 },
                })}
                <div className={getTextClasses(link.to)}>{link.label}</div>
                {isActive(link.to) && (
                  <div className="w-1 h-6 bg-white rounded-full ml-2"></div>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="lg:hidden mt-2">
        {navLinks.map((link, index) => (
          <Link
            key={index}
            to={link.to}
            className={getMobileLinkClasses(link.to)}
          >
            <div className="flex items-center">
              {React.cloneElement(link.icon, {
                className: "flex-none mx-2",
                sx: { color: getIconColor(link.to), fontSize: 25 },
              })}
              <div className={getMobileTextClasses(link.to)}>{link.label}</div>
              {isActive(link.to) && (
                <div className="w-1 h-6 bg-white rounded-full ml-auto mr-2"></div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SideBar;
